import { ProductRoot } from '@/components/ProductFullDetail-new/types/product';

export const useGetColorNumber = ({
  product,
  fabricLabel,
  optionSpecs,
}: {
  product: ProductRoot;
  fabricLabel: string;
  optionSpecs: string[];
}) => {
  const { ampProtOption } = product || {};
  const { items } = ampProtOption || {};

  // amp color number
  const colorNumber = items?.find(item => {
    if (fabricLabel) {
      return item?.label?.includes(fabricLabel?.replace('-default', ''));
    }

    return item?.label?.includes('Color');
  })?.values?.length;

  // configurable color number
  const configurableColorNumber = Array.isArray(product.available_product?.variants)
    ? product.available_product?.variants.reduce((acc, variant) => {
        const colorValueIndex = variant?.attributes?.find(option => option?.code === 'color')?.value_index;

        if (!colorValueIndex || variant.product?.stock_status !== 'IN_STOCK') {
          return acc;
        }

        acc.add(colorValueIndex);

        return acc;
      }, new Set()).size
    : 0;

  return {
    colorNumber,
    configurableColorNumber: configurableColorNumber,
  };
};
